import { html, type TemplateResult } from 'lit';

/**
 * Pixel-Art Top Arrow Icon SVG
 * Rendered on a 16x16 pixel grid with crispEdges shape rendering.
 */
export function iconPixelArrowUp(size = 14): TemplateResult {
  return html`
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 16 16"
      fill="currentColor"
      shape-rendering="crispEdges"
      style="display: inline-block; vertical-align: -0.15em; flex-shrink: 0;"
    >
      <path d="M7 2h2v2H7zM5 4h6v2H5zM3 6h10v2H3zM7 8h2v7H7z" />
    </svg>
  `;
}
